(function() {
  if (window.CAProductMediaHydration) {
    window.CAProductMediaHydration.initAll(document);
    return;
  }

  function hydrateImage(img) {
    if (!img || !img.hasAttribute('data-product-deferred-media')) return;

    if (img.dataset.srcset) {
      img.setAttribute('srcset', img.dataset.srcset);
      img.removeAttribute('data-srcset');
    }

    if (img.dataset.sizes) {
      img.setAttribute('sizes', img.dataset.sizes);
      img.removeAttribute('data-sizes');
    }

    if (img.dataset.src) {
      img.setAttribute('src', img.dataset.src);
      img.removeAttribute('data-src');
    }

    img.removeAttribute('data-product-deferred-media');

    var wrapper = img.closest && img.closest('image-element');
    if (wrapper && wrapper.hasAttribute('data-aos')) {
      wrapper.classList.add('aos-init', 'aos-animate');
    }
  }

  function hydrateSlide(slide) {
    if (!slide) return;
    slide.querySelectorAll('img[data-product-deferred-media]').forEach(hydrateImage);
  }

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.caProductMediaHydrationReady === 'true') return;
    gallery.dataset.caProductMediaHydrationReady = 'true';

    function hydrateSelected() {
      hydrateSlide(gallery.querySelector('.product-main-slide.is-selected'));
    }

    function hydrateAll() {
      gallery.querySelectorAll('img[data-product-deferred-media]').forEach(hydrateImage);
    }

    function hydrateNearDesktopMedia() {
      var desktopQuery = window.matchMedia && window.matchMedia('(min-width: 1025px)');
      if (!desktopQuery || !desktopQuery.matches) return;

      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var preloadDistance = Math.max(900, viewportHeight);

      gallery.querySelectorAll('img[data-product-deferred-media]').forEach(function(img) {
        var rect = img.getBoundingClientRect();
        if (rect.bottom < -300 || rect.top > viewportHeight + preloadDistance) return;

        hydrateImage(img);
      });
    }

    var desktopHydrationScheduled = false;
    function scheduleHydrateNearDesktopMedia() {
      if (desktopHydrationScheduled) return;
      desktopHydrationScheduled = true;

      requestAnimationFrame(function() {
        desktopHydrationScheduled = false;
        hydrateNearDesktopMedia();
      });
    }

    hydrateSelected();
    hydrateNearDesktopMedia();
    setTimeout(hydrateNearDesktopMedia, 250);
    setTimeout(hydrateNearDesktopMedia, 1000);
    gallery.addEventListener('click', hydrateAll, { once: true, passive: true });
    gallery.addEventListener('pointerdown', hydrateAll, { once: true, passive: true });
    gallery.addEventListener('touchstart', hydrateAll, { once: true, passive: true });
    gallery.addEventListener('focusin', hydrateAll, { once: true });
    window.addEventListener('resize', scheduleHydrateNearDesktopMedia, { passive: true });
    window.addEventListener('scroll', scheduleHydrateNearDesktopMedia, { passive: true });
    document.addEventListener('variant:change', hydrateSelected);

    if ('MutationObserver' in window) {
      new MutationObserver(hydrateSelected).observe(gallery, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
      });
    }

    if ('IntersectionObserver' in window) {
      var mobileQuery = window.matchMedia && window.matchMedia('(max-width: 1024px)');
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting || entry.intersectionRatio <= 0.05) return;

          var slide = entry.target.closest('.product-main-slide');
          if (!slide) return;
          if (mobileQuery && mobileQuery.matches && !slide.classList.contains('is-selected') && !slide.classList.contains('starting-slide')) return;

          hydrateImage(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '900px 0px' });

      gallery.querySelectorAll('img[data-product-deferred-media]').forEach(function(img) {
        observer.observe(img);
      });
    }
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (root.matches && root.matches('[data-ca-product-media-hydration]')) {
      initGallery(root);
    }
    root.querySelectorAll('[data-ca-product-media-hydration]').forEach(initGallery);
  }

  window.CAProductMediaHydration = {
    init: initGallery,
    initAll: initAll,
    hydrateImage: hydrateImage
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();
